import { StreamActions } from "@hotwired/turbo"

// custom action per turbo per fare il reload dei turbo frame con src
StreamActions.reload = function() {
  this.targetElements.forEach((e) => {
    if (!e.reload) { return }
    // evitiamo di fare il reload se siamo in edit delle preferenze
    if (e.getAttribute('src')?.endsWith('/edit')) { return }
    const timeout = this.getAttribute('timeout')
    clearTimeout(e.reload_timer)
    if (timeout === 'false') {
      e.reload()
    } else {
      // facciamo il reload dopo qualche sec, se arrivano altri reload prima cancelliamo il precedente
      e.reload_timer = setTimeout(() => e.reload(), parseInt(timeout) || 5000)
    }
  })
}

// custom action per fare il redirect da una risposta turbo stream
StreamActions.redirect = function () {
  const location = this.getAttribute("location") || ""
  Turbo.visit(location)
}
